import { toast } from "react-toastify";
import { AUTORIZACIONES_API } from "../views/MainLayout/components/shared/services/autorizacionesCredito";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

const initialState = {
    total_items: 0,
    pedidos: [],
};

export const autorizacionesReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'autorizaciones/fullfilled':
            return action.payload;
        case 'autorizaciones/update-view':
            return {
                total_items: state.total_items - 1,
                pedidos: state.pedidos.filter(
                    (item) => item.id !== action.payload
                ),
            };

        default:
            return state;
    }
};

export const fetchAutorizacionesCredito = (page, search) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await AUTORIZACIONES_API.get(page, search)
        .catch(function (error) {
            toast.error(setErrorMessage(error.message))
        });
        const data = await response.data;
        dispatch({ type: 'autorizaciones/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}

export const removeItemFromView = (idToDelete) => ({
    type: 'autorizaciones/update-view',
    payload: idToDelete,
});